<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 mal-text custom-title">{{ responseData.event }}<br>{{ page_title }}</h3>
        </div>
    </div>
    <div class="section">
        <div class="row mt-1">
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text">Total</div>
                    <div class="value text-primary">{{ summaryCount('count_total') }}</div>
                </div>
            </div>
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text">{{ membersCardTitle }}</div>
                    <div class="value text-success">{{ summaryCount('count_total_m') }}</div>
                </div>
            </div>
            <div class="col-6 mt-1">
                <div class="stat-box">
                    <div class="title mal-text">Added By Members</div>
                    <div class="value text-warning">{{ summaryCount('count_total_mp') }}</div>
                </div>
            </div>
            <div class="col-6 mt-1">
                <div class="stat-box">
                    <div class="title mal-text">Public</div>
                    <div class="value text-danger">{{ summaryCount('count_total_p') }}</div>
                </div>
            </div>
        </div>
    </div>
    <div id="search">
        <form class="search-form" v-if="$route.params.sub_level == 1">
            <label class="label text-primary" style="margin-bottom:0px;" for="stay"><span>District</span></label>
            <div class="form-group searchbox mal-text">
                <select as="select" class="form-control custom-select" v-model="filter_district" name="filter_district" id="select4" @change="onDistrictFilterChange($event.target.value)">
                    <option value>All</option>
                    <option v-for="district in district_list" v-bind:key="district.id" v-bind:value="district.id">
                        {{ district.name }}
                    </option>
                </select>
                <i class="input-icon"><ion-icon name="filter-outline"></ion-icon></i>
            </div>
        </form>
        <form class="search-form" v-if="$route.params.sub_level == 2">
            <label class="label text-primary" style="margin-bottom:0px;" for="stay"><span>Zone</span></label>
            <div class="form-group searchbox mal-text">
                <select as="select" class="form-control custom-select" v-model="filter_zone" name="filter_zone" id="select4" @change="onZoneFilterChange($event.target.value)">
                    <option value>All</option>
                    <option v-for="zone in zone_list" v-bind:key="zone.id" v-bind:value="zone.id">
                        {{ zone.name }}
                    </option>
                </select>
                <i class="input-icon"><ion-icon name="filter-outline"></ion-icon></i>
            </div>
        </form>
        <form class="search-form" v-if="$route.params.sub_level == 3">
            <label class="label text-primary" style="margin-bottom:0px;" for="stay"><span>Unit</span></label>
            <div class="form-group searchbox mal-text">
                <select as="select" class="form-control custom-select" v-model="filter_unit" name="filter_unit" id="select4" @change="onUnitFilterChange($event.target.value)">
                    <option value>All</option>
                    <option v-for="unit in unit_list" v-bind:key="unit.id" v-bind:value="unit.id">
                        {{ unit.name }}
                    </option>
                </select>
                <i class="input-icon"><ion-icon name="filter-outline"></ion-icon></i>
            </div>
        </form>
        <form class="search-form" v-if="showExamCenterFilter">
            <label class="label text-primary" style="margin-bottom:0px;" for="exam-center-filter"><span>Exam Center</span></label>
            <div class="form-group searchbox mal-text">
                <select id="exam-center-filter" class="form-control custom-select" v-model="filter_center" :disabled="loading_centers" @change="onCenterFilterChange">
                    <option value="">All</option>
                    <option v-for="center in center_list" :key="center.id" :value="center.id">
                        {{ centerLabel(center) }}
                    </option>
                </select>
                <i class="input-icon"><ion-icon name="location-outline"></ion-icon></i>
            </div>
        </form>
        <form class="search-form">
            <label class="label text-primary" style="margin-bottom:0px;" for="stay"><span>Fees Status</span></label>
            <div class="form-group searchbox mal-text">
                <select as="select" class="form-control custom-select" v-model="filter_fees" name="filter_fees" id="select4" @change="getMembersList(1,filter_district,filter_zone,filter_unit,$event.target.value,filter_user_type)">
                    <option value>All</option>
                    <option value="Pending">Pending</option>
                    <option value="Paid">Paid</option>
                </select>
                <i class="input-icon"><ion-icon name="filter-outline"></ion-icon></i>
            </div>
        </form>
        <form class="search-form">
            <label class="label text-primary" style="margin-bottom:0px;" for="wing-filter"><span>Wing</span></label>
            <div class="form-group searchbox mal-text">
                <select id="wing-filter" class="form-control custom-select" v-model="filter_wing" @change="getMembersList(1, filter_district, filter_zone, filter_unit, filter_fees, filter_user_type)">
                    <option value="">All</option>
                    <option value="1">Org (Wisdom)</option>
                    <option value="2">Youth</option>
                    <option value="3">Students</option>
                    <option value="4">Women</option>
                    <option value="6">Girls</option>
                </select>
                <i class="input-icon"><ion-icon name="filter-outline"></ion-icon></i>
            </div>
        </form>
        <form class="search-form" v-if="$route.params.sub_level <= 2">
            <label class="label text-primary" style="margin-bottom:0px;" for="stay"><span>User Type</span></label>
            <div class="form-group searchbox mal-text">
                <select as="select" class="form-control custom-select" v-model="filter_user_type" name="filter_user_type" id="select4" @change="getMembersList(1,filter_district,filter_zone,filter_unit,filter_fees,$event.target.value)">
                    <option value>All</option>
                    <option value="Member">Member</option>
                    <option value="AddByMember">Added By Member</option>
                    <option value="Public" v-if="!filter_zone && !filter_unit">Public</option>
                </select>
                <i class="input-icon"><ion-icon name="filter-outline"></ion-icon></i>
            </div>
        </form>
    </div>
    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="listed-detail mt-0">
        <h4 class="text-center mt-0 mal-text" v-if="!loading_list && member_lists.total <= 0">ഇതുവരെ ആരെയും ചേർത്തിട്ടില്ല
        </h4>
    </div>
    
    <ul class="listview image-listview inset text mt-2" v-if="!loading_list && member_lists.total > 0">
        <li
            v-for="(member_list, index) in member_lists.data"
            v-bind:key="member_list.id"
            class="registration-report-row"
            :class="{ 'registration-report-row--public': isPublicRegistrant(member_list) }"
        >
            <a href="javascript:void(0)" class="item">
                    <span class="sl-no">{{ (member_lists.from + index) }}</span>
                    <div class="avatar-section">
                        <a href="#">
                            <img src="assets/img/sample/avatar/avatar1.png" alt="avatar" class="image">
                            <span class="button verified" v-if="member_list.payment_status == 'Paid' && permissions.fees">
                                <ion-icon name="checkmark-outline"></ion-icon>
                            </span>
                            <span class="button not-verified" v-if="member_list.payment_status == 'Pending' && permissions.fees">
                                <ion-icon name="close-outline"></ion-icon>
                            </span>
                        </a>
            </div>
            <div class="in">
                <div class="min-width-50">
                    <!-- <header>User</header> -->
                    <b> {{ member_list.name }} </b>
                    <footer class="text-primary">{{ member_list.mobile }}
                    </footer>
                    <footer class="text-muted small" v-if="examCenterNameFor(member_list)">
                        {{ examCenterNameFor(member_list) }}
                    </footer>
                </div>
                <div class="card-button dropdown">
                    <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal" :data-bs-target="'#actionSheetInset' + member_list.id" @click="showActionModel">
                                <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                            </button>
                </div>
    
                <!-- Default Action Sheet Inset -->
                <div class="modal fade action-sheet" :id="'actionSheetInset' + member_list.id" tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Action</h5>
                            </div>
                            <div class="modal-body">
                                <ul class="action-button-list">
    
                                    <li>
                                        <a :href="'tel:' + member_list.mobile" class="btn btn-list">
                                                    <span>
                                                        <ion-icon name="call-outline"></ion-icon> Call
                                                    </span>
                                                </a>
                                    </li>
                                    <!-- <li v-if="permissions.fees">
                                        <a href="javascript:void(0)" @click="adminPayment(member_list)" class="btn btn-list" data-bs-dismiss="modal">
                                                    <span>
                                                        <ion-icon name="card-outline"></ion-icon> Payment
                                                    </span>
                                        </a>
                                    </li> -->
                                    <!-- <li>
                                        <a href="javascript:void(0)" @click="adminDeleteConfirmation(member_list)" class="btn btn-list" data-bs-dismiss="modal">
                                                    <span>
                                                        <ion-icon name="trash-outline"></ion-icon> Remove
                                                    </span>
                                                </a>
                                    </li> -->
                                    <li class="action-divider"></li>
                                    <li>
                                        <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                    <span>
                                                        <ion-icon name="close-outline"></ion-icon> Cancel
                                                    </span>
                                                </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- * Default Action Sheet Inset -->
            </div>
            </a>
        </li>
    </ul>
    <div class="section mt-2" v-if="!loading_list">
        <vue-awesome-paginate v-if="member_lists.total > 0" :total-items="member_lists.total" :items-per-page="member_lists.per_page" :max-pages-shown="3" v-model="member_lists.current_page" :on-click="getMembersList" :show-ending-buttons="true" :show-breakpoint-buttons="false"
        />
    </div>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params" ref="dialog_model"></dialog-model>
</template>

<script>
import UserService from "../../services/user.service";
import $ from 'jquery';
import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";
export default {
    name: 'Nerpatham Report',
    components: {
        AlertModel,
        DialogModel
    },
    props: {
        unit_id: null
    },
    data() {
        return {
            loading: false,
            loading_list: false,
            message: "",
            country_code: '91',
            country_code_whatsapp: '91',
            mobile_number: '',
            whatsapp_number: '',
            wing: '',
            stay: '',
            user_level: "",
            sub_levels: [],
            member_lists: [],
            member_list: [],
            member: [],
            member_edit: true,
            orgnal_member_lists: [],
            trash_list: [],
            unit: [],
            editable_id: '',
            editable: false,
            permissions: [],
            add_admin: false,
            abroad_fields: false,
            pin_number: '',
            attendance: 'A',
            attendance_remarks: '',
            search_qty: '',
            member_id: '',
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            attendance_present: [],
            attendance_absent: [],
            filter_wing: '',
            isMember: '',
            user_level_id:'',
            isSubscriber: '',
            receipt_no: '',
            subscription_no: '',
            isEdit: false,
            count_total: 0,
            count_target: 0,
            level: [],
            nerpatham_target: '',
            target_title: 'ടാർഗറ്റ്',
            page_title: 'റിപ്പോർട്ട്',
            series: [0, 0],
            chartOptions: {
                chart: {
                    width: '100%',
                    type: 'pie',
                },
                colors: ['#64b167', '#db7491'],
                labels: ['Target', 'Total'],
                responsive: [{
                    breakpoint: 100,
                    options: {
                        chart: {
                            width: '100%'
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
            responseData: {
                permissions: [],
                count_total: 0,
                count_total_m: 0,
                count_total_mp: 0,
                count_total_p: 0,
            },
            district_list : [],
            zone_list : [],
            unit_list : [],
            center_list : [],
            loading_centers: false,

            filter_district:'',
            filter_zone:'',
            filter_unit:'',
            filter_center:'',
            filter_fees:'',
            filter_user_type:''
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        minusToZero() {
            let value = this.count_target - this.count_total;
            if (value <= 0) {
                return '0';
            } else {
                return value;
            }
        },
        showExamCenterFilter() {
            return String(this.$route.params.exam || '').toUpperCase() === 'QHLS';
        },
        membersCardTitle() {
            if (!this.filter_wing) {
                return 'Members';
            }
            const labels = {
                '1': 'Members (Org)',
                '2': 'Members (Youth)',
                '3': 'Members (Students)',
                '4': 'Members (Women)',
                '6': 'Members (Girls)',
            };
            return labels[String(this.filter_wing)] || 'Members';
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            this.user_level_id = parseInt(this.$route.params.id);
            this.getMembersList();
            this.$root.updateParent('Registration Report');
            if(this.user_level == 1){
                this.getComboboxValues('DISTRICT_KERALA');
            }else if(this.user_level == 2){
                this.getZoneList(this.user_level_id);
            }else if(this.user_level == 3){
                this.getUnitList(this.user_level_id);
            }
            if (this.showExamCenterFilter) {
                this.loadExamCenters();
            }
        }

        window.onpopstate = function() {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
    methods: {
        summaryCount(key) {
            const v = this.responseData && this.responseData[key];
            if (v === undefined || v === null || v === '') {
                return '00';
            }
            return v;
        },
        isPublicRegistrant(m) {
            if (!m) return false;
            const ut = String(m.user_type ?? m.registration_user_type ?? '').trim().toLowerCase();
            if (ut === 'public' || ut === 'p') return true;
            if (m.is_public === true || m.is_public === 1 || m.is_public === '1' || m.is_public === 'Y') return true;
            const rt = String(m.registration_type ?? '').toLowerCase();
            if (rt.includes('public')) return true;
            const mt = String(m.member_type ?? '').trim().toLowerCase();
            if (mt === 'public') return true;
            return false;
        },
        centerLabel(center) {
            if (!center) return '';
            if (center.madrasa_name) return center.madrasa_name;
            if (center.convenor_name) return center.convenor_name;
            return 'Center #' + center.id;
        },
        examCenterNameFor(row) {
            if (!row) return '';
            if (row.exam_center_name) return row.exam_center_name;
            const centerId = row.qhls_exam_center_id;
            if (!centerId) return '';
            const match = (this.center_list || []).find((c) => String(c.id) === String(centerId));
            return match ? this.centerLabel(match) : ('Center #' + centerId);
        },
        examCenterRequestParams() {
            const params = {};
            if (this.user_level === 4 || this.$route.params.sub_level == '4') {
                const unitId = parseInt(this.$route.params.id, 10);
                if (unitId) params.unit_id = unitId;
                return params;
            }
            if (this.filter_unit) {
                params.unit_id = this.filter_unit;
                return params;
            }
            if (this.user_level === 3 || this.$route.params.sub_level == '3') {
                const zoneId = this.filter_zone || parseInt(this.$route.params.id, 10);
                if (zoneId) params.zone_id = zoneId;
                return params;
            }
            if (this.filter_zone) {
                params.zone_id = this.filter_zone;
                return params;
            }
            const districtId = this.resolveDistrictIdForCenters();
            if (districtId) {
                params.district_id = districtId;
            }
            return params;
        },
        resolveDistrictIdForCenters() {
            if (this.user_level === 2) {
                return parseInt(this.$route.params.id, 10) || null;
            }
            if (!this.filter_district) {
                return null;
            }
            const match = (this.district_list || []).find((d) => String(d.id) === String(this.filter_district));
            if (match && match.item_value != null && match.item_value !== '') {
                return parseInt(match.item_value, 10) || match.item_value;
            }
            return this.filter_district;
        },
        loadExamCenters() {
            if (!this.showExamCenterFilter) {
                this.center_list = [];
                return;
            }
            const params = this.examCenterRequestParams();
            this.loading_centers = true;
            UserService.authGetRequest('qhls-exam-centers', params).then(
                (response) => {
                    if (response.data.status === 'success' && Array.isArray(response.data.data?.list)) {
                        this.center_list = response.data.data.list;
                        if (this.filter_center && !this.center_list.some((c) => String(c.id) === String(this.filter_center))) {
                            this.filter_center = '';
                        }
                    } else {
                        this.center_list = [];
                    }
                    this.loading_centers = false;
                },
                () => {
                    this.center_list = [];
                    this.loading_centers = false;
                }
            );
        },
        onDistrictFilterChange(district) {
            this.filter_district = district || '';
            this.filter_center = '';
            this.loadExamCenters();
            this.getMembersList(1, district, this.filter_zone, this.filter_unit, this.filter_fees, this.filter_user_type);
        },
        onZoneFilterChange(zone) {
            this.filter_zone = zone || '';
            this.filter_center = '';
            this.loadExamCenters();
            this.getMembersList(1, this.filter_district, zone, this.filter_unit, this.filter_fees, this.filter_user_type);
        },
        onUnitFilterChange(unit) {
            this.filter_unit = unit || '';
            this.filter_center = '';
            this.loadExamCenters();
            this.getMembersList(1, this.filter_district, this.filter_zone, unit, this.filter_fees, this.filter_user_type);
        },
        onCenterFilterChange() {
            this.getMembersList(1, this.filter_district, this.filter_zone, this.filter_unit, this.filter_fees, this.filter_user_type);
        },
        getMembersList(page = 1, district = null,zone = null,unit = null,fees = null,user_type = null) {
            this.loading_list = true;
            if(zone || unit){
                user_type = '';
                this.filter_user_type = '';
            }
            let data = {
                user_level: this.user_level,
                user_level_id: parseInt(this.$route.params.id),
                exam_type: this.$route.params.exam,
                district_id: district?district:this.filter_district,
                zone_id: zone?zone:this.filter_zone,
                unit_id:unit?unit:this.filter_unit,
                qhls_exam_center_id: this.filter_center || '',
                fees_status:fees?fees:this.filter_fees,
                user_type: user_type?user_type:this.filter_user_type,
                wing: this.filter_wing === '' || this.filter_wing === null ? '' : String(this.filter_wing),
            }
            
            UserService.authPostRequest(`get-exam-event-detailed-report?page=${page}`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.responseData = response.data.data;
                        this.permissions = response.data.data.permissions;
                        this.member_lists = response.data.data.list;
                        this.level = response.data.data.level;
                        this.count_target = response.data.data.count_target;
                        this.count_total = response.data.data.count_total;
                        this.level = response.data.data.level;
                        this.target_title = response.data.data.target_title;
                        this.page_title = response.data.data.page_title;
                        this.loading_list = false;
                    } else {
                        this.loading_list = false;
                    }
                },
                (error) => {
                    this.loading_list = false;
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getComboboxValues(code, id = null) {
            var data = {
                code: code,
                type_id: id
            }
            UserService.getCombobox(data).then(
                (response) => {
                    switch (code) {
                        case 'DISTRICT_KERALA':
                            this.district_list = response.data.data.list.options;
                            break;
                        default:
                            break;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getZoneList(district_id) {
            this.loading_list = true;
            let data = {
                district_id: district_id
            }
            UserService.authPostRequest(`get-zone-by-id`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.zone_list = response.data.data.list;
                        this.loading_list = false;
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    if (error)
                        this.loading_list = true;
                    this.zone_list = [];
                }
            );
        },
        getUnitList(zone_id) {
            this.loading_list = true;
            let data = {
                zone_id: zone_id
            }
            UserService.authPostRequest(`get-unit-by-id`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.unit_list = response.data.data.list;
                        this.loading_list = false;
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    if (error)
                        this.loading_list = true;
                    this.zone_list = [];
                }
            );
        },
    },
};
</script>

<style scoped>
.registration-report-row--public {
    background-color: #fff1f2 !important;
}
.registration-report-row--public .item {
    background-color: transparent !important;
}
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.listview {
    /* margin-bottom: 20px; */
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    /* font-size: 28px; */
    margin-bottom: 14px;
    padding-left: 10px;
}

.wallet-card {
    padding-bottom: 0px !important;
}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.wallet-card .balance .title {
    color: #27173E;
    font-weight: 500;
    font-size: 16px;
    display: block;
    margin-bottom: 8px;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 10px 10px;
}

.wallet-card .balance {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    height: auto;
}

.left {
    margin-left: 20px;
}

.wallet-card {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 0px 16px;
    position: relative;
    z-index: 1;
}
</style>